<template>
  <b-row>
    <StepperCol :step="5" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        エアコンのタイプを選択してください
      </h5>
      <h5 v-if="skipped" class="text-muted">回答はご無用です</h5>
      <template v-else>
        <b-collapse v-model="shrinking" class="d-md-none">
          <b-button
            variant="outline-warning"
            size="lg"
            class="btn-gd text-left position-relative py-2"
            block
            @click="shrinking = false"
          >
            <span class="h4 m-0">{{
              a0Selected ? "6~12畳用" : a1Selected ? "12~20畳用" : "20~32畳用"
            }}</span>
            <div class="d-block text-muted">
              {{ a0Selected ? "¥19,800-" : a1Selected ? "¥25,300-" : "¥29,700-" }}
            </div>
            <div class="accessory-shrinking">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 12 12"
              >
                <polyline
                  fill="none"
                  stroke="#FD9000"
                  stroke-width="2"
                  points="0,6 6,11 12,6"
                />
              </svg>
            </div>
          </b-button>
        </b-collapse>
        <b-collapse v-model="isCollapsed">
          <b-form-row>
            <b-col cols="12" md="4" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-120px"
                :class="a0Selected ? 'selected' : ''"
                @click="buttonClicked(0)"
              >
                <b-row no-gutters class="h-100">
                  <b-col
                    cols="6"
                    class="py-3 pl-3 d-flex flex-column justify-content-between"
                  >
                    <h6 class="h4">6~12畳用</h6>
                    <dl class="text-muted mb-0">
                      <dt>標準工事費用</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">19,800-</span>
                      </dd>
                    </dl>
                  </b-col>
                  <b-col cols="6" class="py-3">
                    <b-img
                      :src="require('@/assets/images/q-4@2x.png')"
                      fluid
                    ></b-img>
                    <div class="pr-3 text-right text-primary">
                      エアコン容量<br />
                      2.8Kw まで
                    </div>
                  </b-col>
                </b-row>
              </b-button>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-120px"
                :class="a1Selected ? 'selected' : ''"
                @click="buttonClicked(1)"
              >
                <b-row no-gutters class="h-100">
                  <b-col
                    cols="6"
                    class="py-3 pl-3 d-flex flex-column justify-content-between"
                  >
                    <h6 class="h4">12~20畳用</h6>
                    <dl class="text-muted mb-0">
                      <dt>標準工事費用</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">25,300-</span>
                      </dd>
                    </dl>
                  </b-col>
                  <b-col cols="6" class="py-3">
                    <b-img
                      :src="require('@/assets/images/q-4@2x.png')"
                      fluid
                    ></b-img>
                    <div class="pr-3 text-right text-primary">
                      エアコン容量<br />
                      5.6Kw まで
                    </div>
                  </b-col>
                </b-row>
              </b-button>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
              <b-button
                class="btn-gd text-left p-0 h-120px"
                :class="a2Selected ? 'selected' : ''"
                @click="buttonClicked(2)"
              >
                <b-row no-gutters class="h-100">
                  <b-col
                    cols="6"
                    class="py-3 pl-3 d-flex flex-column justify-content-between"
                  >
                    <h6 class="h4">20~32畳用</h6>
                    <dl class="text-muted mb-0">
                      <dt>標準工事費用</dt>
                      <dd class="font-weight-bold h5 mb-0">
                        ¥<span class="h3 ml-1">29,700-</span>
                      </dd>
                    </dl>
                  </b-col>
                  <b-col cols="6" class="py-3">
                    <b-img
                      :src="require('@/assets/images/q-4@2x.png')"
                      fluid
                    ></b-img>
                    <div class="pr-3 text-right text-primary">
                      エアコン容量<br />
                      9.0Kw まで
                    </div>
                  </b-col>
                </b-row>
              </b-button>
            </b-col>

          </b-form-row>
        </b-collapse>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      a2Selected: false,
      skipped: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 5) {
        this.collapsed = true;
      } else {
        this.collapsed = false;
      }
    },
    hasConstruction(val, old) {
      old; // eslint-disable-line
      if (val == 0) {
        this.skipped = true;
        this.collapsed = true;
        this.shrinking = false;
        this.selectedAnswer = 3;
      } else {
        this.skipped = false;
        this.shrinking = false;
        // セクション5は maxStep が 5 以上になったときだけ開く（2台目追加時は閉じたまま）
        this.collapsed = this.maxStep >= 5;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      hasConstruction() {
        return this.$store.getters.hasConstruction;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
      this.a2Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
      } else if (value == 1) {
        this.a0Selected = false;
        this.a1Selected = true;
        this.a2Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = true;
      }
      this.doSaveAnswer({ keyword: 'aircon_type', answer: value });
      this.doUpdateStep(6);
      this.shrinking = true;
    },
  },
};
</script>